import "./index.sass";

const HeaderRight = () => {
  return <div className="header-right">EXPERIENCE THE NEXT</div>;
};

export default HeaderRight;
